var _style, _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulmonaryAndCardio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000103223825202872615820000004917673824632258483_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 9,
    y: 9.5,
    width: 85.1,
    height: 85.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114755558523102636870000010256314293011982782_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114755558523102636870000010256314293011982782_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4,57.3c-0.4-3.9-0.9-8-0.9-11.9c0-7.1,0-25.8-12.9-25.8C18.2,19.6,9,54.2,9,72.2c0,2.7,0.1,16.2,4.5,20.6 c1.1,1.1,2.5,1.7,4,1.7c3.1,0,4.8-1.3,6.5-2.6c1.9-1.5,4.5-3.5,11.3-5.4C49.2,82.5,47.7,69.1,46.4,57.3z M33.8,81 c-7.8,2.3-11,4.7-13.2,6.4c-1.5,1.2-1.9,1.5-3,1.5c-1.6-1-3-9-2.9-16.7c0-20.6,10.1-46.9,18-46.9c4.9,0,7.2,6.4,7.2,20.1 c0,4.2,0.5,8.4,0.9,12.5C42.3,71,42.6,78.5,33.8,81z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94,72.2c0-18-9.2-52.6-23.7-52.6c-12.9,0-12.9,18.8-12.9,25.8c0,3.9-0.5,7.9-0.9,11.9c-1.3,11.8-2.8,25.2,11.1,29.2 c6.7,1.9,9.4,4,11.3,5.4c1.8,1.3,3.4,2.6,6.6,2.6c1.5,0,2.9-0.6,4-1.7C93.9,88.3,94.1,74.8,94,72.2z M85.4,88.9 c-1.1,0-1.5-0.3-3-1.5c-2.2-1.6-5.4-4.1-13.2-6.4c-8.9-2.6-8.5-10.1-7-23.1c0.5-4.1,0.9-8.3,0.9-12.5c0-4.1,0.2-10.2,1.6-14.6 c1.6-4.9,3.8-5.5,5.6-5.5c7.9,0,18,26.3,18,46.9C88.4,79.8,87,87.8,85.4,88.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6,44.4c-0.7,0-2.7,0-4.4-4.5c-0.4-1.1-1.5-1.8-2.6-1.8c-1.2,0-2.2,0.7-2.7,1.8c-1.7,4.5-3.7,4.5-4.4,4.5 c-1.6,0-2.8,1.3-2.8,2.8c0,1.6,1.3,2.8,2.8,2.8c2.1,0,4.8-0.7,7.1-3.4c2.3,2.7,4.9,3.4,7.1,3.4c1.6,0,2.8-1.3,2.8-2.8 C61.4,45.7,60.1,44.4,58.6,44.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5,9.5c-1.6,0-2.8,1.2-2.8,2.8v29.1c0,1.6,1.3,2.8,2.8,2.8c1.6,0,2.8-1.3,2.8-2.8V12.4C54.3,10.8,53.1,9.5,51.5,9.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulmonaryAndCardio);
export default __webpack_public_path__ + "static/media/pulmonaryAndCardio.14363c10f318d24f82c0c4173ae91a2a.svg";
export { ForwardRef as ReactComponent };